<template>
    <q-dialog
      v-model="dialog"
      persistent
      rounded
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <q-card>
        <q-bar class="bg-white text-black">
          <q-space />
          <q-btn dense rounded color="accent" size="xs" dark icon="close" @click="cancel()" v-close-popup>
            <q-tooltip class="bg-white text-primary">Close</q-tooltip>
          </q-btn>
        </q-bar>

        <q-card-section class="q-mx-md q-gutter-x-md" horizontal>
          <div class="flex flex-center"><q-icon size="xl" name="img:/assets/icons/trophy.svg" /></div>
          <div class="text-h6 text-center">{{customer}} has a perk to Collect!</div>
        </q-card-section>
        <q-card-section class="text-caption text-right q-my-xs q-py-xs">
          <p class="q-my-none text-weight-thin">Current balance: <strong>{{actualPoints}} point(s)</strong></p>
          <p class="q-my-none text-weight-thin">You're adding: <strong>{{perksQty}} point(s)</strong></p>
        </q-card-section>
        <q-card-section class="text-caption q-ma-sm q-py-sm row">
          <p class="text-weight-thin col text-right">Future balance: <br/>{{ (points > 1) ? points - 1 : 0}} point(s)</p>
          <q-btn :label="'Collect Now'" class="q-ma-sm col-7" color="primary" :loading="scanning" :disable="scanning" @click="savePoints(true)"  />
        </q-card-section>
        <q-card-section class="text-caption q-mx-sm q-py-sm row" v-if="perksQty > 0">
          <p class="text-weight-thin col text-right">Future balance: <br/>{{totalPoints}} point(s)</p>
          <q-btn outline class="q-ma-sm col-7" :label="'Just add ' + perksQty + ' point(s)'" color="primary" padding="xs xs" :loading="scanning" :disable="scanning" @click="savePoints(false)" />
        </q-card-section>
      </q-card>
    </q-dialog>
</template>

<script>
export default {
    name: 'collect-dialog',
    props: ['dialog', 'actualPoints', 'perksQty', 'totalPoints', 'scanning', 'points', 'customer'],
    setup(props, context) {
        const savePoints = (value) => {
          context.emit('save-points', value)
        }
        const cancel = () => {
          context.emit('cancel')
        }
        return {savePoints,cancel}
    },
}
</script>